document.addEventListener("DOMContentLoaded", () => {
	const sliders = document.querySelectorAll(".js-wcs_slider");

	sliders.forEach((slider) => {
		const slides = slider.querySelectorAll(".b-what_clients_say-slide");
		const prevBtn = slider.querySelector(".js-wcs_prev");
		const nextBtn = slider.querySelector(".js-wcs_next");

		if (!slides.length) return;

		let current = 0;

		const showSlide = (index) => {
			slides.forEach((slide, i) => {
				if (i === index) {
					slide.removeAttribute("hidden");
				} else {
					slide.setAttribute("hidden", "");
				}
			});

			if (prevBtn) prevBtn.disabled = slides.length <= 1;
			if (nextBtn) nextBtn.disabled = slides.length <= 1;
		};

		showSlide(0);

		prevBtn?.addEventListener("click", () => {
			current = (current - 1 + slides.length) % slides.length;
			showSlide(current);
		});

		nextBtn?.addEventListener("click", () => {
			current = (current + 1) % slides.length;
			showSlide(current);
		});
	});
});
